
import { Component, Vue, Watch } from 'vue-property-decorator';
import ConfirmDialog from '../src/features/core/components/Modals/ConfirmDialog.vue'
import GlobalSnackbar from '../src/features/core/components/Modals/GlobalSnackbar.vue'
import HighCloudyImageConfirmDialog from '../src/features/item_with_sinisters/components/satellital/HighCloudyImageConfirmDialog.vue'

@Component({
  components: {
    ConfirmDialog,
    GlobalSnackbar,
    HighCloudyImageConfirmDialog,
  }
})
export default class App extends Vue {

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange() {
    // ...
  }

}
